import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectUserId = (state: StoreSchema) => state.user.userData.userId
